<template>
  <div class="date-container" :class="isPc ? 'pc': 'mobile'">
    <div :class="isPc ? 'date-select pc': 'date-select mobile'">
      <el-date-picker
        class="date"
        v-model="internalValue"
        :disabled="isDisabled"
        type="date"
        :placeholder="$t('microSite.form.placeholder.selectDate')"
        value-format="yyyy-MM-dd"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
    },
    title: {
      type: String,
      default: ''
    },
    isPc: {
      type: Boolean,
      default: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: ''
    }
  },
  computed: {
  },
  created () {
    this.internalValue = this.value
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    value: {
      handler (val, oldVal) {
        this.internalValue = val
      },
      immediate: true
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.date-container {
  padding: 10px 0 0 0;

  &.pc {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .date-select {
    &.pc {
      width: 35%;
    }

    .date {
      width: 100%;
    }
  }
}
</style>
